import React, { useEffect } from "react";
import { Table, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { MdRefresh } from "react-icons/md";
import * as type from "../../store/types";

const TransactionTable = ({scroll}) => {
  const dispatch = useDispatch();

  const { subtraction = [], loading, error } = useSelector(
    (state) => state.viewSubTraction || {}
  );

  useEffect(() => {
    dispatch({ type: type.SUBTRANCTION_FETCH_REQUEST });
  }, [dispatch]);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "20vh" }}>
        <div className="loaderMain"></div>
      </div>
    );
  }

  const handleRefresh = ()=>{
    window.location.href='/my-profile'
  }


  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <h5 style={{ color: "black" }}>
          An error has occurred on the server.
        </h5>
        <p style={{color:'blue', cursor:'pointer'}}  onClick={handleRefresh}>
       <MdRefresh style={{marginBottom: '2px',marginRight: '2px',fontSize: '20px'}} /> Refresh to view</p>
      </div>
    );
  }



  const country = localStorage.getItem('country') || ''; 

  const getSymbol = (country) => {
    if (country === "United Kingdom") return '£';
    if (country === "India") return '₹';
    if (country === "Canada") return 'CA$';
    return ''; 
  };
  

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => new Date(date).toLocaleString(), // Format date
    },
    {
      title: "Plan Name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Credits",
      dataIndex: "creditpoints",
      key: "creditpoints",
    },
    {
      title: "Paid Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `${getSymbol(country)} ${amount.toFixed(2)}`,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button onClick={() => handlePrint(record._id)}>
          Print
        </Button>
      ),
    },
  ];

  const handlePrint = (_id) => {
    window.open(`/subscription-bill/${_id}`, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <Table
        dataSource={subtraction.map((item) => ({
          ...item,
          key: item._id,
        }))}
        columns={columns}
        scroll={scroll}
        pagination={{ pageSize: 2 }}
      />
    </div>
  );
};

export default TransactionTable;





